// Tag ID
const pathTagId = window.location.pathname.substr(1);

window.location.href = `https://app.replace.de/scan/product/${pathTagId}`;

export {};